import React from 'react'
import { Button, Row, TextField } from '@fs/zion-ui'

const PersonsTableFilter = ({
  filter,
  setFilter,
  resetResults,
  personsActions,
  downloadPersonsInTree,
  isDownloadDisabled,
  showDownloadLimit,
  t,
}) => {
  return (
    <>
      <Row wrap alignX="start" alignY="middle">
        <TextField
          id="nameFilter"
          label={t('tree.column.nameFilter', 'Name Filter')}
          value={filter}
          clearable
          onEnterKey={() => {
            resetResults()
            personsActions.setNameFilter(filter)
          }}
          onClear={() => {
            setFilter()
            resetResults()
            personsActions.setNameFilter()
          }}
          onChange={(e) => {
            setFilter(e.target.value)
          }}
          type="text"
          fullwidth="true"
        />
        <Button
          onClick={() => {
            resetResults()
            personsActions.setNameFilter(filter)
          }}
        >
          {t('tree.filter', 'Filter')}
        </Button>
        <Button onClick={downloadPersonsInTree} disabled={isDownloadDisabled}>
          {t('tree.persons.download', 'Download Tree Persons')}
        </Button>
      </Row>
      {showDownloadLimit && (
        <div>{t('tree.persons.download.limit', 'More than 100K persons. Unable to download list.')}</div>
      )}
    </>
  )
}

export default PersonsTableFilter
